import { RETRIGGER_PATHOLOGY_AI } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';

const retriggerPathologyAI = createAsyncThunk(
  'retriggerPathologyAI',
  async (payload: { hospitalId: string; wsiId: string; uhid: string }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(RETRIGGER_PATHOLOGY_AI, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      return await response.json();
    } catch (error) {
      return error;
    }
  }
);

export default retriggerPathologyAI;
